<template>
  <div id="signup">
    <el-row>
      <el-col :xs="{span:16,offset:4}" :sm="{span:10,offset:7}" :md="{span:8,offset:8}" :lg="{span:6,offset:9}">
        <el-form :model="signup" ref="signup" status-icon :rules="rules">
          <h3 style="text-align:center;">アカウント新規登録</h3>
          <el-form-item prop="email" label="メールアドレス（ログインID）"
            :rules="[
              { required: true, message: 'メールアドレスを入力してください', trigger: 'blur' },
              { type: 'email', message: 'メールアドレスの形式が正しくありません', trigger: 'blur,change' }
            ]"
          >
            <el-input placeholder="メールアドレス" v-model="signup.email"></el-input>
          </el-form-item>
          <el-form-item prop="password" label="パスワード"
            :rules="{required: true, message: 'パスワードを入力してください', trigger: 'blur'}">
            <el-input type="password" name="password" placeholder="パスワード" v-model="signup.password"></el-input>
          </el-form-item>
          <el-form-item prop="confirm" label="パスワード再入力">
            <el-input type="password" name="password" placeholder="パスワード再入力" v-model="signup.confirm"></el-input>
          </el-form-item>

          <el-form-item label="性別">
            <el-radio v-model="signup.gender" label="1">男性</el-radio>
            <el-radio v-model="signup.gender" label="2">女性</el-radio>
          </el-form-item>

          <el-form-item label="生年月日">
            <el-date-picker
              v-model="signup.birthday"
              type="date"
              placeholder="生年月日"
              default-value="2000-01-01">
            </el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button style="width:100%" type="primary" @click="regist('signup')">新規登録</el-button>
          </el-form-item>
          <el-form-item align="center">
            <div class="info">すでにアカウントをお持ちですか？</div>
            <el-button type="text" @click="$router.push('/login')">ログイン</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'signup',
  data () {
    var self = this
    var validateConfirm = function (rule, value, callback) {
      if (value === '') {
        callback(new Error('確認用パスワードを入力してください'))
      } else if (value !== self.signup.password) {
        callback(new Error('確認用パスワードが一致しません'))
      } else {
        callback()
      }
    }
    return {
      signup: {
        email: '',
        password: '',
        confirm: '',
        gender: '',
        birthday: ''
      },
      rules: {
        confirm: [
          { required: true, validator: validateConfirm, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    console.log('created:login')
  },
  methods: {
    regist (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var signup = {
            id: this.signup.email,
            password: this.signup.password,
            gender: this.signup.gender,
            birthday: this.formatDate(this.signup.birthday, 'YYYY-MM-DD')
          }

          var self = this
          this.$http.post('/user/signup', signup).then(function (response) {
            if (response.result) {
              self.successMessage(response.message, 7000)
              setTimeout(function () {
                self.$router.push('/login')
              }, 7000)
            } else {
              self.errorMessage(response.message)
            }
          })
        } else {
          console.log('error signup')
          return false
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/04-pages/Signup.vue